import React, { useState, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const RegisterPage = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        firstName: '',
        lastName: ''
    });
    const [error, setError] = useState('');
    const { register, loading } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await register(formData.email, formData.password, formData.firstName, formData.lastName);
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.message || 'Registration failed');
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4 py-20 overflow-hidden relative"
            style={{ background: 'linear-gradient(135deg, #0a0a14 0%, #0f172a 50%, #1e1b4b 100%)' }}>
            <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full border border-white/5 pointer-events-none" />
            <div className="absolute -top-12 -right-12 w-64 h-64 rounded-full border border-white/5 pointer-events-none" />
            <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full border border-white/5 pointer-events-none" />
            <div className="absolute top-1/4 left-1/4 w-72 h-72 rounded-full opacity-15 pointer-events-none"
                style={{ background: 'radial-gradient(circle, #6366f1 0%, transparent 70%)' }} />

            <div className="relative w-full max-w-md">
                <div className="text-center mb-8">
                    <img src="/logo.svg" alt="DOCTAPE" className="h-12 w-auto mx-auto mb-4" />
                    <h2 className="text-3xl font-bold text-white">Create account</h2>
                    <p className="text-slate-400 font-light mt-2 text-sm">Join thousands of healthcare professionals</p>
                </div>

                <div className="rounded-3xl p-8 border border-white/10"
                    style={{ background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(20px)' }}>

                    {error && (
                        <div className="mb-6 px-4 py-3 rounded-2xl text-red-300 text-sm font-light"
                            style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)' }}>
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-slate-300 mb-2">First Name</label>
                                <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required placeholder="Jane"
                                    className="w-full px-4 py-3 rounded-2xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all duration-300 text-sm"
                                    style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' }} />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-300 mb-2">Last Name</label>
                                <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required placeholder="Smith"
                                    className="w-full px-4 py-3 rounded-2xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all duration-300 text-sm"
                                    style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' }} />
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-300 mb-2">Email</label>
                            <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="you@example.com"
                                className="w-full px-4 py-3 rounded-2xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all duration-300 text-sm"
                                style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' }} />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-slate-300 mb-2">Password</label>
                            <input type="password" name="password" value={formData.password} onChange={handleChange} required placeholder="••••••••"
                                className="w-full px-4 py-3 rounded-2xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all duration-300 text-sm"
                                style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' }} />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full text-white font-semibold py-4 rounded-2xl transition-all duration-300 disabled:opacity-50 mt-2 hover:-translate-y-0.5"
                            style={{ background: 'linear-gradient(135deg, #2563eb, #4f46e5)', boxShadow: '0 8px 32px rgba(59,130,246,0.3)' }}
                        >
                            {loading ? 'Creating account…' : 'Create Account'}
                        </button>
                    </form>
                </div>

                <p className="text-center text-slate-500 mt-6 text-sm font-light">
                    Already have an account?{' '}
                    <a href="/login" className="text-blue-400 hover:text-blue-300 font-medium transition-colors">Sign in here</a>
                </p>
            </div>
        </div>
    );
};

export default RegisterPage;
